/**
 * The shell's breakpoints, for the rare JS that genuinely needs to know which
 * side of one it is on.
 *
 * Responsive *layout* belongs in `@media`, per `02-shell-architecture.md`
 * Rule 3. This module is not a way around that rule; it exists for the residue
 * CSS cannot express, which so far is exactly two things: whether Escape should
 * dismiss a floating rail, and whether the sidebar's `v-show`n labels should be
 * rendered at all. Both are behaviour, not geometry.
 *
 * These values are duplicated from `assets/scss/_breakpoints.scss`, which is
 * the source of truth. That duplication is deliberate and is guarded by
 * `test/unit/core/utils/breakpoints.spec.js`, which parses the SCSS and fails
 * if the two ever disagree.
 *
 * The obvious alternative -- exporting them from SCSS via a `:export` block in
 * a `*.module.scss`, the way `colors.module.scss` does -- does not work here.
 * Vite treats `.module.scss` as CSS Modules and rewrites every key in the
 * `:export` block into a scoped, hashed class name, so `breakpoints.md` comes
 * back as `_md_4a7f55` rather than `1200px`. `colors.module.scss` gets away
 * with it because its only consumer (`utils/colors.js`) reads `Object.keys()`
 * and never looks at a value.
 */

// Keep in sync with `$breakpoint-sm` / `$breakpoint-md` in
// `modules/core/assets/scss/_breakpoints.scss`.
export const BREAKPOINT_SM = 768
export const BREAKPOINT_MD = 840

/**
 * A `max-width` media query string that is the exact complement of the
 * `below()` SCSS mixin, which is exclusive of the breakpoint. Deriving the
 * off-by-one here rather than writing `1199px` at the call site keeps the
 * subtraction next to the value it applies to.
 */
export function below(breakpoint) {
  return `(max-width: ${breakpoint - 1}px)`
}
